/**
 * Detects errors that all seem to be related to the same issue that we have
 * yet to reproduce. It makes sense to group them as the same error.
 *
 * @param {object} report The report object
 * @returns {boolean} Returns true if the report matches
 * @example
 *   "Can't find variable: $"
 *   "'growl' is undefined"
 *   "ProfileModalContainer is not defined"
 */
function referenceError(report) {
  if (
    report.errorMessage.includes("Can't find variable") ||
    report.errorMessage.includes("is not defined") ||
    report.errorMessage.includes("is undefined")
  ) {
    report.groupingHash = "ReferenceError";

    return true;
  }

  return false;
}

export default referenceError;
